export default "/images/vendor/flag-icons/flags/1x1/mw.svg?bc758281555fb3749de0824f0aadb345";